import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useCallback } from 'react';
import { isFunction } from "../../utils/is-function";
import { useControlledComponent } from "../../hooks";
import { Menu, MenuRadioGroup } from "../Menu";
/**
 * Select
 *
 * A popover menu with a list of selectable options.
 * Its effectively a radio-group which appears in a dropdown
 * menu. It composes Popover, Menu, MenuList, MenuRadioGroup.
 */

export function Select(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      content = _ref.content,
      children = _ref.children,
      label = _ref.label,
      tooltip = _ref.tooltip,
      other = _objectWithoutProperties(_ref, ["value", "onChange", "defaultValue", "content", "children", "label", "tooltip"]);

  var _useControlledCompone = useControlledComponent(value, onChange, defaultValue),
      _useControlledCompone2 = _slicedToArray(_useControlledCompone, 2),
      checked = _useControlledCompone2[0],
      setChecked = _useControlledCompone2[1];

  var renderChildren = useCallback(function (_ref2) {
    var isShowing = _ref2.isShowing;

    if (!children) {
      return null;
    }

    return isFunction(children) ? children({
      isShowing: isShowing,
      value: checked
    }) : children;
  }, [checked, children]);
  return /*#__PURE__*/React.createElement(Menu, _extends({}, other, {
    tooltip: tooltip,
    content: /*#__PURE__*/React.createElement(MenuRadioGroup, {
      label: label,
      checked: checked,
      onChange: setChecked
    }, content)
  }), renderChildren);
}